/**
 * Экран «не найдено»: клиент не нашёл **своего** маршрута.
 *
 * Он не отвечает ни на вопрос о правах, ни на вопрос о существовании объекта —
 * и то и другое знает сервер, а адрес, набранный руками, это всего лишь адрес.
 * Отсюда и текст: он говорит про страницу, а не про данные.
 *
 * Обращения к серверу у экрана нет ни одного, и состояний у него нет тоже:
 * показывать нечего и ждать нечего.
 */

import type { Strings } from '../i18n';

export interface NotFoundScreen {
  readonly element: HTMLElement;
}

export function createNotFoundScreen(strings: Strings): NotFoundScreen {
  const element = document.createElement('section');
  const heading = document.createElement('h1');

  element.className = 'screen screen-not-found';
  heading.textContent = strings.not_found_title;
  element.append(heading);

  return { element };
}
